export enum OutboundModal {
  INVALID_GAYLORD_CODE = "INVALID_GAYLORD_CODE",
  EMPTY_GAYLORD_CODE = "EMPTY_GAYLORD_CODE",
  UNRECOGNIZED_TRACKING_CODE = "UNRECOGNIZED_TRACKING_CODE",
  INCORRECT_ASSIGNMENT = "INCORRECT_ASSIGNMENT",
  REPRINT_SHIPPING_LABEL_CONFIRMATION = "REPRINT_SHIPPING_LABEL_CONFIRMATION",
  GAYLORD_TYPE_CONFIRMATION = "GAYLORD_TYPE_CONFIRMATION",
  INVALID_GAYLORD_TYPE_FOR_QUINCE_AIR = "INVALID_GAYLORD_TYPE_FOR_QUINCE_AIR",
  INVALID_GAYLORD_TYPE_FOR_QUINCE_GROUND = "INVALID_GAYLORD_TYPE_FOR_QUINCE_GROUND",
  GAYLORD_STAGED_NO_MORE_PACKAGE_ASSIGNMENT = "GAYLORD_STAGED_NO_MORE_PACKAGE_ASSIGNMENT",
  INVALID_PACKAGE_TYPE_FOR_MASTER_CARTON = "INVALID_PACKAGE_TYPE_FOR_MASTER_CARTON",
  MASTER_CARTON_ALREADY_ASSIGNED_TO_PALLET = "MASTER_CARTON_ALREADY_ASSIGNED_TO_PALLET",
  ACTIVE_MAPPING_NOT_FOUND = "ACTIVE_MAPPING_NOT_FOUND",
}
